import React, {useEffect} from "react";
import {connect} from "react-redux";
import {AutoSizer, List} from "react-virtualized";

import {showPricingPopup} from "../pricingActions";
import PricingPopupContext, {usePricingPopupContext} from "./PricingPopupContext";
import PricingFeatureRow from "../PricingFeatures/PricingFeatureRow";
import {
  getFeaturePropertiesGridColumnStyles, useGetPricingFilteredFeatures
} from "../PricingFeatures/pricingFeaturesFunctions";
import PricingFeaturesListTableHeader from "../PricingFeatures/PricingFeaturesListTableHeader";
import PricingPopupAssignFeaturesFilters from "./PricingPopupAssignFeaturesFilters";


const PricingPopupAssignFeatures = (props) => {

  const {pricingFeaturesReceived, pricingFeaturesList, searchTerm, selectedFilters, pricingFeaturesColumns,
    pricingEditedFeatures} = props;
  const {pricingPopupState, pricingPopupDispatch} = usePricingPopupContext(PricingPopupContext);
  const {assignCatalogFeatures, activeCatalog} = pricingPopupState;

  const featuresList = useGetPricingFilteredFeatures(
    pricingFeaturesList,
    pricingFeaturesReceived,
    searchTerm,
    selectedFilters
  );

  const allChecked = assignCatalogFeatures.length === featuresList.length;

  useEffect(() => {
    pricingPopupDispatch({
      assignCatalogFeatures: featuresList.filter(dbFeature => {
        return dbFeature.catalogs && dbFeature.catalogs.includes(activeCatalog.id)
      }),
    })
  }, [pricingFeaturesReceived, featuresList]);

  if (!pricingFeaturesReceived) {
    return (
      <div className="pr-popup__content flex-item scrollbar3 mt-125 mb-125 pr-1 flex flex--center">
        <div className="ui-loader"/>
      </div>
    )
  }

  let columns = ["checkbox", ...pricingFeaturesColumns];
  const styles = getFeaturePropertiesGridColumnStyles(columns);

  return (
    <div className="pr-popup__content flex-item scrollbar3 mt-125 mb-125 pr-1 flex">
      <PricingPopupAssignFeaturesFilters/>
      <div className="pr-assign__features pl-1 width-100 pr-grid--light">
        <PricingFeaturesListTableHeader styles={styles}
                                        className="pr-grid--with-checkbox"
                                        columns={columns}
                                        selectAllChecked={allChecked}
                                        selectAllClick={() => pricingPopupDispatch({
                                          assignCatalogFeatures: allChecked
                                            ? assignCatalogFeatures.filter(featureDefinition_id => {
                                              return !featuresList.some(dbFeature => dbFeature.featureDefinition_id === featureDefinition_id)
                                            })
                                            : [...assignCatalogFeatures, ...featuresList.filter(dbFeature => {
                                              return !assignCatalogFeatures.includes(dbFeature.featureDefinition_id)
                                            }).map(dbFeature => dbFeature.featureDefinition_id)]
                                        })} />
        <AutoSizer>
          {({width, height}) => {
            return (
              <List
                autoHeight
                height={height}
                rowCount={featuresList.length}
                rowHeight={44}
                rowRenderer={({index, key, style}) => {
                  if (!featuresList[index]) {
                    return null
                  }
                  return <PricingFeatureRow dbFeature={featuresList[index]}
                                            pricingEditedFeatures={pricingEditedFeatures}
                                            index={index}
                                            key={key}
                                            columns={columns} style={{...style, ...styles}}/>
                }}
                width={width}
              />
            )
          }}
        </AutoSizer>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingFeaturesList, pricingFeaturesReceived, pricingFeaturesColumns, pricingEditedFeatures} = store.pricingState;
  const {selectedFilters} = store.featuresFiltersState;
  const {searchTerm} = store.featuresSetupState;

  return {
    pricingFeaturesReceived,
    pricingFeaturesList,
    searchTerm,
    pricingFeaturesColumns,
    selectedFilters,
    pricingEditedFeatures,
  };
};

const mapDispatchToProps = {
  showPricingPopup
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(PricingPopupAssignFeatures)
)
